import * as Yup from "yup";
import { AsyncSelectValue } from "../../../../AsyncSelect";
import { UploadEducationMaterialDocumentFormatEnum } from "../../../../../services";

const FILE_FORMATS = [
  ".txt",
  ".jpeg",
  ".jpg",
  ".png",
  ".gif",
  ".mp4",
  ".pdf",
  ".psd",
  ".ai",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
];

export const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Document Title"),
  // documentDate: Yup.date().nullable().required("Date is required"),
  // description: Yup.string().required("Document Description is required"),
  providerId: Yup.object().required().label("Provider"),
  isEditFile: Yup.boolean(),
  // specialityId: Yup.string().required("Speciality is required"),
  file: Yup.mixed()
    // .when( "isEditFile", {
    // is: (value: boolean) => !value,
    // then: (schema) =>
    // schema
    ?.required("File is  a required field")
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value) return false;
      else if (typeof value === "string" && value.startsWith("https:"))
        return true;
      const ext = (value as any)?.name?.split(".").pop()?.toLowerCase();
      return FILE_FORMATS.some((f) => f.replace(".", "") === ext);
    }),
  // otherwise: (schema) => schema.notRequired().nullable(),
  // }),
});

export const INITIAL_VALUES = {
  providerId: null,
  isEditFile: false,
  specialityId: undefined,
  name: "",
  description: "",
  condition: "",
  fileName: "",
  documentFormat: "",
  file: null,
  documentDate: null,
};

export type EducationMaterial = {
  providerId: AsyncSelectValue | null;
  specialityId: string;
  name: string;
  description: string;
  condition: string;
  fileName: string;
  documentFormat: UploadEducationMaterialDocumentFormatEnum;
  file: File;
  documentDate: string | null;
};
